<div class="filters-section">
  <!-- Row 1: Filter Buttons -->
  @if (filterButtons.length > 0) {
    <div class="filters-row filters-row-status">
      @if (filterButtonsLabel) {
        <label class="filters-label">{{ filterButtonsLabel }}</label>
      }
      <div class="filter-buttons">
        @for (btn of filterButtons; track btn) {
          <button
            [class.active]="activeFilter === btn.value"
            [ngClass]="btn.colorClass || ''"
            (click)="onFilterClick(btn.value)">
            @if (btn.icon) {
              <i [class]="btn.icon"></i>
            }
            {{ btn.label }}
            @if (btn.count !== undefined) {
              <span class="contador">{{ btn.count }}</span>
            }
          </button>
        }
      </div>
    </div>
  }

  <!-- Row 2: Search + Selects -->
  @if (showSearch || filterSelects.length > 0) {
    <div class="filters-row filters-row-search">
      @if (showSearch) {
        <input
          type="text"
          class="search-input"
          [placeholder]="searchPlaceholder"
          [ngModel]="searchValue"
          (ngModelChange)="onSearchInput($event)" />
      }
      @for (select of filterSelects; track select) {
        <div class="filter-group">
          <label>{{ select.label }}:</label>
          <select
            class="filter-select"
            [ngModel]="select.value"
            (ngModelChange)="onSelectChange(select.label, $event)">
            @for (opt of select.options; track opt) {
              <option [value]="opt.value">
                {{ opt.label }}
                @if (opt.count !== undefined) {
                  ({{ opt.count }})
                }
              </option>
            }
          </select>
        </div>
      }
      <!-- Custom Filters (via content projection) -->
      <ng-content></ng-content>
    </div>
  }
</div>
